import axios from "axios";
import serialize from "json-form-data";
import { FINE_GROUP_ALT } from "@/constants/fineAndBonusGroups";
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const apiUrl = "index.php";
const ARCHIVED = 1;
const NOT_ARCHIVED = 0;

const setFineArchiveStatus = (state, fineId, categoryId, status) => {
    if (categoryId) {
        const group = state.fineGroups.find((g) => g.id.toString() === categoryId.toString());
        const fine = group.items.find((v) => v.id === fineId);
        fine.is_archive = status;
        const isAnyArchivedItems = group.items.some((i) => i.is_archive.toString() === "1");
        if (!isAnyArchivedItems) {
            group.hasItems = 0;
        }
        return;
    }
    const fine = state.fines.find((s) => s.id.toString() === fineId.toString());
    fine.is_archive = status;
};

const setQueryParams = (filters, queryParams) => {
    if (filters.status && filters.status !== "all") {
        queryParams.push(`status_type=${filters.status === "archived" ? "archive" : "active"}`);
    }
    if (filters.positions && filters.positions.length) {
        const positions = filters.positions.map((p) => (filters.positionsExcept ? `-${p.value}` : p.value));
        queryParams.push(`post_codes=${positions.join(",")}`);
    }
    if (filters.name) {
        queryParams.push(`search=${filters.name}`);
    }
};

const findAndUpdateFineEntity = (fines, updatedFine, state) => {
    let fine = fines.find((v) => v.id.toString() === updatedFine.id.toString());

    if (fine.category_id!==updatedFine.category_id) {
        let items = fine.category_id ? state.fineGroups.find((group) => group.id === fine.category_id).items : state.fines;
        const index = items.findIndex((i)=> i.id==fine.id);
        if (index>=0) {
            fine = items.splice(index, 1)[0];
            items = updatedFine.category_id ? state.fineGroups.find((group) => group.id.toString() === updatedFine.category_id.toString()).items : state.fines;
            items.unshift(fine);
        }
    }

    fine.finePosts = updatedFine.post_code.map((post_code) => ({ post_code }));
    Object.keys(updatedFine).forEach((key) => {
        fine[key] = updatedFine[key];
    });
};

const state = () => ({
    fineGroups: [],
    fines: [],
    positions: [],
    lastFineGroupIdOfCreatedItem: 0,
    lastChangeWasGroupSorting: false,

    collections: {
        fines: [],
    },
});

const getters = {
    getFinesByGroupId: (state) => (groupId) => state.fineGroups.find((g) => groupId === g.id).items,
    getFines: (state) => (fineId) => {
        const fineWithoutGroup = state.fines.find((v) => v.id.toString() === fineId.toString());
        if (fineWithoutGroup) {
            return fineWithoutGroup;
        }

        const groupsFines = state.fineGroups.reduce((acc, currentGroup) => {
            if (currentGroup.items && currentGroup.items.length) {
                acc = [...acc, ...currentGroup.items];
            }
            return acc;
        }, []);

        return groupsFines.find((v) => v.id.toString() === fineId.toString());
    },
    isAnyArchivedItem: (state) => {
        const allViolations = state.fineGroups.reduce((acc, currentGroup) => {
            if (currentGroup.items && currentGroup.items.length) {
                acc = [...acc, ...currentGroup.items];
            }
            return acc;
        }, []);
        return [...state.fines, ...allViolations].some((v) => v.is_archive.toString() === "1");
    },
    isAnyItemExists: (state) => state.fines.length || state.fineGroups.length,
    getFinesCollection: (state) => state.collections.fines,
};

const mutations = {
    setPositions(state, positions) {
        state.positions = positions;
    },
    setFines(state, fines) {
        state.fines = fines;
    },
    setFinesCollection(state, fines) {
        state.collections.fines = fines;
    },
    setFinesToGroup(state, { id, items }) {
        const group = state.fineGroups.find((group) => group.id === id);
        group.items = items;
    },
    setFineGroups(state, groups) {
        state.fineGroups = [];
        state.fineGroups = groups
            .filter((g) => g.type === FINE_GROUP_ALT)
            .map((group) => {
                const finePosts = group.finePosts ? group.finePosts : [];
                return { ...group, items: group.items ? group.items : [], finePosts };
            });
    },
    putNewFine(state, { model, categoryId }) {
        const newFine = {
            ...model,
            postFines: [],
            is_archive: 0,
            repeatFines: model.repeatFines ? model.repeatFines : [],
        };
        model.post_code.forEach((code) => {
            newFine.postFines.push({
                post_code: code,
            });
        });
        if (!categoryId) {
            state.fines.unshift(newFine);
            return;
        }
        state.lastFineGroupIdOfCreatedItem = categoryId;
        const group = state.fineGroups.find((g) => g.id === categoryId);
        if (!group.items) {
            return;
        }
        group.items.unshift(newFine);
    },
    putNewFineGroup(state, group) {
        state.fineGroups.unshift({ ...group, hasItems: 0, items: [] });
    },
    updateFine(state, fineData) {
        if (!fineData.category_id) {
           // findAndUpdateFineEntity(state.fines, fineData);
            //return;
        }

        let groupsFines = state.fineGroups.reduce((acc, currentGroup) => {
            if (currentGroup.items && currentGroup.items.length) {
                acc = [...acc, ...currentGroup.items];
            }
            return acc;
        }, []);
        groupsFines = [...groupsFines, ...state.fines]


        findAndUpdateFineEntity(groupsFines, fineData, state);
    },
    updateFineGroup(state, updatedGroup) {
        const group = state.fineGroups.find((g) => g.id === updatedGroup.id);
        Object.keys(group).forEach((key) => {
            if (key in updatedGroup) {
                group[key] = updatedGroup[key];
            }
        });
    },
    deleteFine(state, { id, categoryId }) {
        if (!categoryId) {
            state.fines = state.fines.filter((s) => s.id !== id);
            return;
        }
        const group = state.fineGroups.find((group) => group.id.toString() === categoryId.toString());
        group.items = group.items.filter((i) => i.id !== id);
        if (!group.items.length) {
            group.hasItems = 0;
            group.hasArchivedItems = 0;
        }
    },
    deleteFineGroup(state, id) {
        const groupIndex = state.fineGroups.findIndex((g) => g.id === id);
        state.fineGroups.splice(groupIndex, 1);
    },
    moveFineToArchive(state, { fineId, categoryId }) {
        setFineArchiveStatus(state, fineId, categoryId, ARCHIVED);
    },
    moveFineFromArchive(state, { fineId, categoryId }) {
        setFineArchiveStatus(state, fineId, categoryId, NOT_ARCHIVED);
    },
    updateFineCategory(state, { categoryId, fine }) {
        const group = state.fineGroups.find((g) => g.id === categoryId);
        if (!group) {
            state.fines.find((v) => v.id === fine.id).category_id = null;
            return;
        }
        group.items.find((v) => v.id === fine.id).category_id = categoryId;
    },
    setLastChangeWasGroupSortingValue(state, value) {
        state.lastChangeWasGroupSorting = value;
    },
};

const actions = {
    async fetchPositions({ rootState, commit }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/directory/position`, token);

        const { data } = await axios.get(url);

        const positions = [];
        Object.entries(data).forEach(([positionsCode, position]) => {
            positions.push({
                label: position.name,
                value: positionsCode,
            });
        });
        commit("setPositions", positions);
    },
    async fetchFines({ rootState, commit }, filters) {
        const token = rootState.authToken;

        const queryParams = [];

        queryParams.push(`categories=${filters.categories.length ? filters.categories.join(",") : null}`);

        setQueryParams(filters, queryParams);

        const url = addAuthKey(`${apiUrl}/?r=api/fine/index&${queryParams.join("&")}&sort=-sort`, token);

        const { data } = await axios.get(url);

        const [firstCategory] = filters.categories;

        if (firstCategory && filters.categories.length === 1) {
            commit("setFinesToGroup", { items: data, id: firstCategory });
            return;
        }
        commit("setFines", data);
    },
    async getFinesCollection({ rootState, commit }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/fine/index`, token);
        const { data } = await axios.get(url);
        commit("setFinesCollection", data);
    },
    async fetchFinesGroups({ rootState, commit }, filters) {
        const token = rootState.authToken;
        const queryParams = [];

        if (filters) {
            setQueryParams(filters, queryParams);
        }

        const url = addAuthKey(`${apiUrl}/?r=api/bonus-fine-category/index&${queryParams.join("&")}&sort=-sort`, token);

        const { data } = await axios.get(url);
        commit("setFineGroups", data);
    },
    async createFine({ rootState, commit }, fineData) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/fine/create`, token);

        const { files, ...params } = fineData;
        const formData = serialize(params);

        files.forEach((file) => {
            formData.append("files[]", file);
        });

        const { data } = await axios.post(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        if (data.success) {
            commit("putNewFine", {
                model: { ...data.model, post_code: fineData.post_code },
                categoryId: fineData.category_id,
            });
        }

        return data.success;
    },
    async createFineGroup({ rootState, commit }, groupName) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/bonus-fine-category/create`, token);

        const { data } = await axios.post(url, { name: groupName, type: FINE_GROUP_ALT });

        if (data.success) {
            commit("putNewFineGroup", data.model);
        }

        return data;
    },
    async changeFineCategory({ rootState, commit }, { categoryId, fine }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/fine/update&id=${fine.id}`, token);

        await axios.put(url, { category_id: categoryId });

        commit("updateFineCategory", { categoryId, fine });
    },
    async changeFinesSort({ rootState }, sortingData) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/fine/update-sort`, token);

        await axios.patch(url, sortingData);
    },
    async deleteFine({ rootState, commit }, { id, categoryId }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/fine/delete&id=${id}`, token);

        const { data } = await axios.delete(url);

        if (data.success) {
            commit("deleteFine", { id, categoryId });
        }
    },
    async deleteFineGroup({ rootState, commit }, id) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/bonus-fine-category/delete&id=${id}`, token);

        const { data } = await axios.delete(url);

        if (data.success) {
            commit("deleteFineGroup", id);
        }
    },
    async moveFineToArchive({ rootState, commit }, { fineId, categoryId }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/fine/archive&id=${fineId}`, token);

        const { data } = await axios.patch(url);

        if (data.success) {
            commit("moveFineToArchive", { fineId, categoryId });
        }
        return data.success;
    },
    async moveFineFromArchive({ rootState, commit }, { fineId, categoryId }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/fine/archive&id=${fineId}&is_archive=0`, token);

        const { data } = await axios.patch(url);

        if (data.success) {
            commit("moveFineFromArchive", { fineId, categoryId });
        }

        return data.success;
    },
    async updateFine({ rootState, commit }, fineData) {
        const token = rootState.authToken;
        const { id, files, ...params } = fineData;
        const url = addAuthKey(`${apiUrl}/?r=api/fine/update&id=${id}`, token);

        if (!params.category_id) params.category_id='';
        const formData = serialize(params);

        files.forEach((file) => {
            formData.append("files[]", file);
        });

        const { data } = await axios.put(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        if (data.success) {
            commit("updateFine", {
                ...data.model,
                post_code: fineData.post_code,
            });
        }

        return data.success;
    },
    async updateFineGroup({ rootState, commit }, fineGroupData) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/bonus-fine-category/update&id=${fineGroupData.id}`, token);

        const { data } = await axios.put(url, fineGroupData);

        if (data.success) {
            commit("updateFineGroup", data.model);
        }

        return data;
    },
    async updateGroupsSort({ rootState, state, commit }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/bonus-fine-category/update-sort`, token);

        const sortingData = state.fineGroups.map((group, groupIndex) => ({
            id: group.id,
            sort: state.fineGroups.length - groupIndex,
        }));

        commit("setLastChangeWasGroupSortingValue", false);

        await axios.patch(url, sortingData);
    },
    async updateSort({ rootState, state }, categoryId) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/fine/update-sort`, token);

        const sortingData = [];

        if (!categoryId) {
            state.fines.forEach((v, vIndex) => {
                sortingData.push({ id: v.id, sort: state.fines.length - vIndex });
            });
        } else {
            const group = state.fineGroups.find((g) => g.id === categoryId);
            group.items.forEach((v, vIndex) => {
                sortingData.push({ id: v.id, sort: group.items.length - vIndex });
            });
        }

        await axios.patch(url, sortingData, {
            headers: {
                "Content-Type": "application/json",
            },
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
